export default __webpack_public_path__ + "static/media/mockup.441c92ff.png";